<!-- app.component.html -->
<div>
  <router-outlet></router-outlet>
</div>
